import { axiosInstance } from './ApiConfig';

const CACHE_KEY = 'allPdcCacheV1';
const DAY_MS = 24 * 60 * 60 * 1000;
let inflightPromise = null;

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function writeCache(data) {
  try {
    const payload = { timestamp: Date.now(), data };
    localStorage.setItem(CACHE_KEY, JSON.stringify(payload));
  } catch {}
}

function isFresh(ts) {
  return typeof ts === 'number' && Date.now() - ts < DAY_MS;
}

export async function FetchPdc({ level, force = false } = {}) {
  // temporary pass level
  const cached = readCache();
  if (!force && cached && isFresh(cached.timestamp)) {
    return cached.data;
  }

  if (inflightPromise) {
    try {
      const data = await inflightPromise;
      return data;
    } catch (e) {}
  }

  inflightPromise = (async () => {
    try {
      const response = await axiosInstance({
        method: 'GET',
        url: '/pdc',
        headers: {
          user_level: level,
        },
      }); // temporary add level here

      if (response.status === 200) {
        const data = response.data.value;
        writeCache(data);
        return data;
      }
      throw new Error('Failed to fetch PDC data');
    } catch (err) {
      const stale = readCache();
      if (stale?.data) return stale.data;
      throw err;
    } finally {
      inflightPromise = null;
    }
  })();

  return inflightPromise;
}
